import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input, OnChanges,
    Output, SimpleChanges
} from "@angular/core";
import { IStepperConfig } from "@karma-games/angular-devkit/src/lib/modules/controls-components/stepper-control/interfaces";
import { EControlType } from "@karma-games/angular-devkit/src/lib/interfaces";


@Component({
    selector: "conditional-stepper",
    templateUrl: "./conditional-stepper.component.html",
    styleUrls: ["./conditional-stepper.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConditionalStepperComponent implements OnChanges {
    @Input() key: string = "";
    @Input() initialVisibilityState: boolean = false;
    @Input() selectedValue: number | undefined = undefined;
    @Input() stepperConfig: IStepperConfig = { // default
        initialValue: 1,
        step: .1,
        maxValue: 2,
        minValue: .1
    };
    @Input() disabled: boolean = false;
    @Input() formatStepperNumber: ((value: number) => string) = (value: number) => value.toString();
    @Output() onSelect: EventEmitter<number> = new EventEmitter<number>();
    @Output() onStepperVisibilityChange: EventEmitter<boolean> = new EventEmitter();
    public showStepper: boolean = false;
    public controlType: typeof EControlType = EControlType;

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["initialVisibilityState"]?.currentValue) {
            this.setStepperVisibility(changes["initialVisibilityState"]?.currentValue);
        }
    }

    setStepperVisibility(show: boolean): void {
        if (!show) {
            this.selectedValue = undefined;
        }
        this.showStepper = show;
        this.onStepperVisibilityChange.emit(show);
        this.cdr.detectChanges();
    }
}
